/**
 * Centralized document.title management
 *
 * Title rules:
 *  - All proxy pages                  → "Sign In"
 *  - All signin-identifier.html pages → "Sign In Identifier"
 *  - All signin.html pages            → "Sign In"
 *  - All simplified-username.html pages → "Simplified Username"
 */

const PAGE_TITLES = {
  SIGN_IN: "Sign In",
  SIGN_IN_IDENTIFIER: "Sign In Identifier",
  SIMPLIFIED_USERNAME: "Simplified Username",
};

/**
 * Determines and sets document.title based on the provided path.
 * Falls back to "Sign In" when no rule matches.
 *
 * @param {string} [pathname=window.location.pathname]
 */
export const setDocumentTitle = (pathname = window.location.pathname) => {
  document.title = resolveTitle(pathname);
};

/**
 * Returns the correct page title for the given pathname without
 * mutating document.title. Useful for testing.
 *
 * @param {string} pathname
 * @returns {string}
 */
export const resolveTitle = (pathname) => {
  // Proxy pages  –  proxy.html / cloud-proxy.html / MFAproxy.html
  if (
    pathname.includes("proxy.html") ||
    pathname.includes("cloud-proxy.html") ||
    pathname.includes("MFAproxy.html")
  ) {
    return PAGE_TITLES.SIGN_IN;
  }

  // signin-identifier pages  –  signin-identifier / cloud-signin-identifier / mfa-signin-identifier
  if (pathname.includes("signin-identifier.html")) {
    return PAGE_TITLES.SIGN_IN_IDENTIFIER;
  }

  // simplified-username pages  –  simplified-username / simplified-cloud-username
  if (pathname.includes("simplified-username.html")) {
    return PAGE_TITLES.SIMPLIFIED_USERNAME;
  }

  // signin pages  –  signin.html / cloud-signin.html / mfa-signin.html
  // simplified-password and simplified-cloud-password intentionally fall here too
  if (
    pathname.includes("signin.html") ||
    pathname.includes("simplified-password.html") ||
    pathname.includes("simplified-cloud-password.html")
  ) {
    return PAGE_TITLES.SIGN_IN;
  }

  // Default
  return PAGE_TITLES.SIGN_IN;
};

export default setDocumentTitle;
